import { get } from '../api-config';

const tcpService = '/tcp';

export const getDeviceRequestSograce = (id: any, params: any) =>
  get(tcpService, `/devices/${id}/command`, null, params);
